import { Injectable } from '@angular/core';
import { ApModalComponentType } from 'webcommon/core-ui';
import { ApFindControlModalComponent } from './ap-findcontrol-modal.component';

// the default configuration for find controls, can override by providing a different implementation
// in a module, component, etc
@Injectable({
  providedIn: 'root',
})
export class ApFindControlConfig {
  readonly findControlModalById = new Map<string, ApModalComponentType<ApFindControlModalComponent>>();
  readonly defaultModal: ApModalComponentType<ApFindControlModalComponent> = ApFindControlModalComponent;
}
